const ALUMINUM = [
  {
    name: "Natural Satin Aluminum",
    code: "FCAL_NSA",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    upcharge: 1,
  },
  {
    name: "Polished Natural Aluminum",
    code: "FCAL_PNA",
    hex: "#AEC2CF",
    rgb: "rgb(174, 194, 207)",
    upcharge: 1.75,
  },
  {
    name: "Clear Anodized Aluminum",
    code: "FCAL_CAA",
    hex: "#D1D2CD",
    rgb: "rgb(209, 210, 205)",
    upcharge: 1.25,
  },
  {
    name: "Gold Anodized Aluminum",
    code: "FCAL_GAA",
    hex: "#BD9244",
    rgb: "rgb(189, 146, 68)",
    upcharge: 1.25,
  },
  {
    name: "Medium Bonze Anodized",
    code: "FCAL_MBA",
    hex: "#504940",
    rgb: "rgb(80, 73, 64)",
    upcharge: 1.25,
  },
  {
    name: "Dark Bronze Anodized Aluminum",
    code: "FCAL_DBA",
    hex: "#413C3A",
    rgb: "rgb(65, 60, 58)",
    upcharge: 1.25,
  },
  {
    name: "Black Anodized Aluminum",
    code: "FCAL_BAA",
    hex: "#2B2E31",
    rgb: "rgb(43, 46, 49)",
    upcharge: 1.25,
  },
  {
    name: "Polished Clear Anodized",
    code: "FCAL_PCA",
    hex: "#CED3D9",
    rgb: "rgb(206, 211, 217)",
    upcharge: 1.75,
  },
  {
    name: "Polished Gold Anodized",
    code: "FCAL_PGA",
    hex: "#BD9244",
    rgb: "rgb(189, 146, 68)",
    upcharge: 2.0,
  },
  {
    name: "Polished Medium Bronze Anodized",
    code: "FCAL_PMB",
    hex: "#584F45",
    rgb: "rgb(88, 79, 69)",
    upcharge: 2.0,
  },
  {
    name: "Polished Dark Bronze Anodized",
    code: "FCAL_PDB",
    hex: "#413C3A",
    rgb: "rgb(65, 60, 58)",
    upcharge: 2.0,
  },
  {
    name: "Polished Black Anodized",
    code: "FCAL_PBA",
    hex: "#2B2E31",
    rgb: "rgb(43, 46, 49)",
    upcharge: 2.0,
  },
];

const BL32FINISH = [
  {
    name: "Natural Satin Bronze",
    code: "FCBZ_NSB",
    hex: "#B48F6B",
    rgb: "rgb(180, 143, 107)",
    upcharge: 1.0,
  },
  {
    name: "Polished Bronze",
    code: "FCBZ_PBZ",
    hex: "#D4A878",
    rgb: "rgb(212, 168, 120)",
    upcharge: 1.5,
  },
  {
    name: "Oxidized Bronze",
    code: "FCBZ_OBZ",
    hex: "#5E4C43",
    rgb: "rgb(94, 76, 67)",
    upcharge: 1.15,
  },
  {
    name: "Dark Oxidize Bronze",
    code: "FCBZ_DOB",
    hex: "#5F504B",
    rgb: "rgb(95, 80, 75)",
    upcharge: 1.15,
  },
];

const BL33FINISH = [
  {
    name: "Natural Satin Brass",
    code: "FCBR_NSB",
    hex: "#C5AD8B",
    rgb: "rgb(197, 173, 139)",
    upcharge: 1.0,
  },
  {
    name: "Polished Brass",
    code: "FCBR_PB",
    hex: "#E4C899",
    rgb: "rgb(228, 200, 153)",
    upcharge: 1.5,
  },
  {
    name: "Dark Oxidized Brass",
    code: "FCBR_DOB",
    hex: "#938278",
    rgb: "rgb(147, 130, 120)",
    upcharge: 1.15,
  },
  {
    name: "Oxidized Brass",
    code: "FCBR_OB",
    hex: "#6C5B49",
    rgb: "rgb(108, 91, 73)",
    upcharge: 1.15,
  },
];

const BL402FINISH = [
  {
    name: "Brushed Aluminum",
    code: "FCMA_BSA",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    upcharge: 1.0,
  },
  {
    name: "Polished Natural Aluminum",
    code: "FCMA_SSA",
    hex: "#C0cAD3",
    rgb: "rgb(192, 202, 211)",
    upcharge: 1.0,
  },
  {
    name: "Satin Gold",
    code: "FCMA_BSG",
    hex: "#BFC562",
    rgb: "rgb(191, 197, 98)",
    upcharge: 1.0,
  },
  {
    name: "Gold Anodized Aluminum",
    code: "FCMA_GAA",
    hex: "#BD9244",
    rgb: "rgb(189, 146, 68)",
    upcharge: 1.0,
  },
  {
    name: "Brushed Light Brass",
    code: "FCMA_BSB",
    hex: "#D6C65D",
    rgb: "rgb(214, 198, 93)",
    upcharge: 1.0,
  },
  {
    name: "Brushed Brass",
    code: "FCMA_SSB",
    hex: "#A6914D",
    rgb: "rgb(166, 145, 77)",
    upcharge: 1.0,
  },
  {
    name: "Polished Brass",
    code: "FCMA_BAA",
    hex: "#D4BC5F",
    rgb: "rgb(212, 188, 95)",
    upcharge: 1.0,
  },
  {
    name: "Brushed Medium Bronze",
    code: "FCMA_BBR",
    hex: "#5E4C33",
    rgb: "rgb(94, 76, 51)",
    upcharge: 1.0,
  },
];

const BL20FINISH = [
  {
    name: "Natural Satin Aluminum",
    code: "Natural_Satin_Aluminum",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    upcharge: 1.0,
  },
  {
    name: "Champagne Anodized",
    code: "Champagne_Anodized",
    hex: "#BFB5B3",
    rgb: "rgb(191, 181, 179)",
    upcharge: 1.25,
  },
  {
    name: "Clear Anodized Aluminum",
    code: "Clear_Anodized_Aluminum",
    hex: "#D1D2CD",
    rgb: "rgb(209, 210, 205)",
    upcharge: 1.25,
  },
  {
    name: "Gold Anodized Aluminum",
    code: "Gold_Anodized_Aluminum",
    hex: "#BD9244",
    rgb: "rgb(189, 146, 68)",
    upcharge: 1.25,
  },
  {
    name: "Medium Bronze Anodzed Aluminum",
    code: "Medium_Bronze_Anodzed_Aluminum",
    hex: "#504940",
    rgb: "rgb(80, 73, 64)",
    upcharge: 1.25,
  },
  {
    name: "Dark Bronze Anodized Aluminum",
    code: "Dark_Bronze_Anodized_Aluminum",
    hex: "#413C3A",
    rgb: "rgb(65, 60, 58)",
    upcharge: 1.25,
  },
  {
    name: "Black Anodized Aluminum",
    code: "Black_Anodized_Aluminum",
    hex: "#2B2E31",
    rgb: "rgb(43, 46, 49)",
    upcharge: 1.25,
  },
  {
    name: "Buffed Brushed Aluminum",
    code: "Buffed_Aluminum",
    hex: "#CED3D9",
    rgb: "rgb(206, 211, 217)",
    upcharge: 2.0,
  },
];

const BL22FINISH = [
  {
    name: "Natural Satin Bronze",
    code: "Natural_Satin_Bronze",
    hex: "#B48F6B",
    rgb: "rgb(180, 143, 107)",
    upcharge: 1.0,
  },
  {
    name: "Oxidized Bronze",
    code: "Oxidized_Bronze",
    hex: "#5E4C4",
    rgb: "rgb(94, 76, 67)",
    upcharge: 1.15,
  },
  {
    name: "Polished Bronze",
    code: "Polished_Bronze",
    hex: "#D4A878",
    rgb: "rgb(212, 168, 120)",
    upcharge: 1.7,
  },
  {
    name: "Dark Oxidized Bronze",
    code: "Dark_Oxidized_Bronze",
    hex: "#5F504B",
    rgb: "rgb(95, 80, 75)",
    upcharge: 1.15,
  },
];

export const FINISHES_MAP = {
  ML1000: null,
  BL2000: BL20FINISH,
  BL2200: BL22FINISH,
  BL31000: ALUMINUM,
  BL32000: BL32FINISH,
  BL33000: BL33FINISH,
  BL40100: null,
  BL40200: null,
  PFL100: null,
  BL70100: null,
};

export const getFinishByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const finishes = FINISHES_MAP[productCode];
  if (!finishes) {
    console.warn(`No finishes defined for product code: ${productCode}`);
    return [];
  }
  return finishes;
};
